/*
 *  This file environment.main.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2023
 *  (C) 2015-2023. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { workFlowIds } from '../app/global/constants/workflow.constant';
import { formIds } from '../app/global/constants/forms.contant';
import { ouIds } from '../app/global/constants/organization-units.constant';
import { moduleIds } from '../app/global/constants/modules.contant';

const placeholders = {
  ph1: '/assets/images/image-placeholder.jpg',
  ph2: './assets/images/employee.png',
  ph3: './assets/images/no-image.png'
};

export const environment = {
  "ZmlyZWJhc2U=": "eyJwcm9qZWN0SWQiOiJocm9uZXY1LXB1c2hub3RpZmljYXRpb24tcHJvZCIsImFwcElkIjoiMTo4NDg3MDA3MzczMzU6d2ViOjM5NjdlNTE2ZTY4OGVhYmNjNTdjYjIiLCJkYXRhYmFzZVVSTCI6Imh0dHBzOi8vaHJvbmV2NS1wdXNobm90aWZpY2F0aW9uLXByb2QuZmlyZWJhc2Vpby5jb20iLCJzdG9yYWdlQnVja2V0IjoiaHJvbmV2NS1wdXNobm90aWZpY2F0aW9uLXByb2QuYXBwc3BvdC5jb20iLCJsb2NhdGlvbklkIjoiYXNpYS1zb3V0aDEiLCJhcGlLZXkiOiJBSXphU3lBZHhiRzJtOXNBWThDdC1zVU83aXVUVE9SYU5faW40cUkiLCJhdXRoRG9tYWluIjoiaHJvbmV2NS1wdXNobm90aWZpY2F0aW9uLXByb2QuZmlyZWJhc2VhcHAuY29tIiwibWVzc2FnaW5nU2VuZGVySWQiOiI4NDg3MDA3MzczMzUiLCJtZWFzdXJlbWVudElkIjoiRy04VDdSWEVQTFpaIn0=",
  "ZmlyZWJhc2VDaGF0": "eyJhcGlLZXkiOiJBSXphU3lDWGhSLURMUVM1OEZnU3VROVFyd2doTF8wR1lFWTB1S0UiLCJhdXRoRG9tYWluIjoiaHJvbmUtY2hhdHMtdGVzdC5maXJlYmFzZWFwcC5jb20iLCJwcm9qZWN0SWQiOiJocm9uZS1jaGF0cy10ZXN0Iiwic3RvcmFnZUJ1Y2tldCI6Imhyb25lLWNoYXRzLXRlc3QuYXBwc3BvdC5jb20iLCJtZXNzYWdpbmdTZW5kZXJJZCI6IjcxNTcyNjI5MjM3MCIsImFwcElkIjoiMTo3MTU3MjYyOTIzNzA6d2ViOjU4YzhmNjJiN2U4NjdiYWUzZmFkNGIifQ==",
  production: false,
  workFlowIds: workFlowIds,
  formIds: formIds,
  ouIds: ouIds,
  moduleIds: moduleIds,
  placeholders: placeholders,
  placeholder_xs: '/assets/images/image-placeholder.jpg',
  placeholder_sm: '/assets/images/image-placeholder.jpg',
  placeholder_md: '/assets/images/image-placeholder.jpg',
  apiVersion: 'v1',
  typingEvent: [91, 8, 9],
  users: {
    skip: 0,
    limit: 10
  },
  messages: {
    skip: 0,
    limit: 15
  }
  ,
  envName: "production",
  domainCode: "hronenew-testing",
  base_url: "https://test.hrone.work",
  base_auth_url: "https://gateway.test.hrone.work",
  stripe_base_url:"https://hronedev-subscription.azurewebsites.net",
  isDeployOnGT: false,
  power_bi_url:"https://dev-powerbi.hrone.work",
  microservice_base_url:"https://gateway.test.hrone.work",
  broadcastUrl: "https://broadcast.test.hrone.work/hubs/presence",
  hropsDeploymentEnable: true,
  isKBEnable: true,
  isGDPRPointerEnabled: true,
  isChatEnabled:true,
  oneAIGPTUrl: "https://oneai.test.hrone.work",
  isVariablePaymentPlanEnable : true,
  apiDocumentUrl:"https://apidocs.hrone.cloud",
  isPayComponentEditOptionEnable: true,
  sourceUrl: 'test.hrone.work',
  legoBaseUrl: "https://staging-api.workone.ai",
  legoOrgId: "",
  legoRedirectUrl: 'https://id.dev.hrone.work',
  legoIFrameUrl: 'https://studio.dev.hrone.work',
  isWhatsappOTPEnabled: true,
  allowedPaymentRedirectHosts: ['smartgateway.hdfcuat.bank.in'],
  // New Relic Browser Monitoring Configuration
  newRelic: {
    enabled: true,
    accountID: '1321654',
    trustKey: '1321654',
    agentID: '718439438',
    licenseKey: 'fa0d766433',
    applicationID: '718439438'
  },
  loginRedirectUrl: 'https://microweb-host.test.hrone.work/login',
  redirectToMicro: false,
  aiInterviewerRedirectUrl: 'https://test-interview.hrone.studio'
};
